import React, { Fragment } from 'react'

import { connect } from 'react-redux'
import { Update_Biodata } from '../../../../../Store/Actions/Account.Action.js'

import { Skeleton, Button, TextField, FormControl, InputLabel, Select } from '@mui/material'

import { OptionalChoice } from '../../../../../Global.js'

class Biodata extends React.Component {
    state = {
        Foto: '',
        Nama: '',
        TempatLahir: '',
        TanggalLahir: '',
        AlamatTinggal: '',
        AlamatKTP: '',
        Telepon: '',
        TelKantor: '',
        Hp: '',
        GolDar: '',
        Agama: '',
        JenisKelamin: '',
        Tinggi: '',
        Berat: '',
        KTP: '',
        KartuKeluarga: '',
        StatusKawin: '',
        Hobi: '',
        SimA: '',
        ExpSimA: '',
        SimB: '',
        ExpSimB: '',
        SimC: '',
        ExpSimC: '',
        Kendaraan: '',
        KendaraanMilik: '',
    }

    onChangeField = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    componentDidMount() {
        const { Biodata } = this.props

        this.setState({
            Nama: Biodata.Nama ? Biodata.Nama : '',
            TempatLahir: Biodata.TempatLahir ? Biodata.TempatLahir : '',
            TanggalLahir: new Date(Biodata.TanggalLahir).toISOString().slice(0, 10),
            AlamatTinggal: Biodata.AlamatTinggal ? Biodata.AlamatTinggal : '',
            AlamatKTP: Biodata.AlamatKTP ? Biodata.AlamatKTP : '',
            Telepon: Biodata.Telepon ? Biodata.Telepon : '',
            TelKantor: Biodata.TelKantor ? Biodata.TelKantor : '',
            Hp: Biodata.Hp ? Biodata.Hp : '',
            GolDar: Biodata.GolDar ? Biodata.GolDar : '',
            Agama: Biodata.Agama ? Biodata.Agama : '',
            JenisKelamin: Biodata.JenisKelamin ? Biodata.JenisKelamin : '',
            Tinggi: Biodata.Tinggi ? Biodata.Tinggi : '',
            Berat: Biodata.Berat ? Biodata.Berat : '',
            KTP: Biodata.KTP ? Biodata.KTP : '',
            KartuKeluarga: Biodata.KartuKeluarga ? Biodata.KartuKeluarga : '',
            StatusKawin: Biodata.StatusKawin ? Biodata.StatusKawin : '',
            Hobi: Biodata.Hobi ? Biodata.Hobi : '',
            SimA: Biodata.SimA === true ? "Ya" : "",
            ExpSimA: Biodata.ExpSimA ? new Date(Biodata.ExpSimA).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
            SimB: Biodata.SimB === true ? "Ya" : "",
            ExpSimB: Biodata.ExpSimB ? new Date(Biodata.ExpSimB).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
            SimC: Biodata.SimC === true ? "Ya" : "",
            ExpSimC: Biodata.ExpSimC ? new Date(Biodata.ExpSimC).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
            Kendaraan: Biodata.Kendaraan ? Biodata.Kendaraan : '',
            KendaraanMilik: Biodata.KendaraanMilik ? Biodata.KendaraanMilik : '',
        })
    }

    File_OnChange = E => {
        this.setState({ [E.target.name]: E.target.files[0] })
    }

    formOnSubmit = (e) => {
        e.preventDefault()

        const BiodataData = this.props.Biodata.Data.Data

        this.props.Update_Biodata(
            BiodataData.Id,
            this.state.Foto,
            this.state.Nama,
            this.state.TempatLahir,
            this.state.TanggalLahir,
            this.state.AlamatTinggal,
            this.state.AlamatKTP,
            this.state.Telepon,
            this.state.TelKantor,
            this.state.Hp,
            this.state.GolDar,
            this.state.Agama,
            this.state.JenisKelamin,
            this.state.Tinggi,
            this.state.Berat,
            this.state.KTP,
            this.state.KartuKeluarga,
            this.state.StatusKawin,
            this.state.Hobi,
            this.state.SimA,
            this.state.ExpSimA,
            this.state.SimB,
            this.state.ExpSimB,
            this.state.SimC,
            this.state.ExpSimC,
            this.state.Kendaraan,
            this.state.KendaraanMilik,
        )
    }

    render() {
        // const BiodataData = this.props.Biodata
        const isBiodataLoading = this.props.isBiodataLoading

        const OpGolonganDarah = ['A', 'B', 'AB', 'O']
        const OpAgama = OptionalChoice.Agama
        const OpJenisKelamin = ['Male', 'Female']
        const OpKawin = OptionalChoice.Kawin
        const OpSIM = ['Ya', 'Tidak']

        const {
            Nama,
            TempatLahir,
            TanggalLahir,
            AlamatTinggal,
            AlamatKTP,
            Telepon,
            TelKantor,
            Hp,
            GolDar,
            Agama,
            JenisKelamin,
            Tinggi,
            Berat,
            KTP,
            KartuKeluarga,
            StatusKawin,
            Hobi,
            SimA,
            ExpSimA,
            SimB,
            ExpSimB,
            SimC,
            ExpSimC,
            Kendaraan,
            KendaraanMilik,
        } = this.state

        const st_textfield = { marginTop: '10px', marginBottom: '10px', width: '100%' }
        const st_20 = { width: '20%', }
        const st_70 = { width: '70%', }
        const st_Half = { width: '45%' }

        return (
            <Fragment>
                {isBiodataLoading ?
                    <Fragment>
                        {
                            [1, 2, 3, 4, 5,].map((item) =>
                                <Skeleton
                                    key={`Biodata_Skeleton_${item}`}
                                    height={'5vh'}
                                />
                            )
                        }
                    </Fragment> :
                    <Fragment>
                        <form
                            onSubmit={this.formOnSubmit}
                        >
                            {/* <Avatar
                                alt="Avatar"
                                src={Foto ? Foto : null}
                                // src={AccountDetail.ProfilePicture ? `${DefaultUrl}/${AccountDetail.ProfilePicture}` : null} 
                                style={{ width: '10vw', height: '10vw', margin: 'auto', marginBottom: '20px', marginLeft: 'auto', display: 'block', position: 'relative' }}
                            /> */}

                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='text'
                                label='Nama Lengkap'
                                name='Nama'
                                onChange={this.onChangeField}
                                required
                                value={Nama ? Nama : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_20 }}
                                variant='outlined'
                                type='text'
                                label='Tempat Lahir'
                                name='TempatLahir'
                                onChange={this.onChangeField}
                                value={TempatLahir ? TempatLahir : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_70, marginLeft: '5%' }}
                                variant='outlined'
                                type='date'
                                label='Tanggal Lahir'
                                name='TanggalLahir'
                                InputLabelProps={{ shrink: true }}
                                onChange={this.onChangeField}
                                required
                                value={TanggalLahir ? TanggalLahir : ''}
                            />
                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='text'
                                label='Alamat Tinggal'
                                name='AlamatTinggal'
                                onChange={this.onChangeField}
                                value={AlamatTinggal ? AlamatTinggal : ''}
                            />
                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='text'
                                label='Alamat KTP'
                                name='AlamatKTP'
                                onChange={this.onChangeField}
                                value={AlamatKTP ? AlamatKTP : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_Half }}
                                variant='outlined'
                                type='number'
                                label='Tlp Rumah'
                                name='Telepon'
                                onChange={this.onChangeField}
                                value={Telepon ? Telepon : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                variant='outlined'
                                type='number'
                                label='Tlp Kantor'
                                name='TelKantor'
                                onChange={this.onChangeField}
                                value={TelKantor ? TelKantor : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_Half }}
                                variant='outlined'
                                type='number'
                                label='Tlp Seluler'
                                name='Hp'
                                onChange={this.onChangeField}
                                value={Hp ? Hp : ''}
                            />
                            <FormControl
                                style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Golongan Darah
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Golongan Darah"
                                    name='GolDar'
                                    value={GolDar ? GolDar : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpGolonganDarah.map((option, index) =>
                                        <option key={`OpGolonganDarah_${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl
                                style={{ ...st_textfield, ...st_Half }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Agama
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Agama"
                                    name='Agama'
                                    value={Agama ? Agama : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpAgama.map((option, index) =>
                                        <option key={`OpAgama${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <FormControl
                                style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Jenis Kelamin
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Jenis Kelamin"
                                    name='JenisKelamin'
                                    value={JenisKelamin ? JenisKelamin : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpJenisKelamin.map((option, index) =>
                                        <option key={`OpJenisKelamin${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <TextField
                                style={{ ...st_textfield, ...st_Half }}
                                variant='outlined'
                                type='number'
                                label='Tinggi'
                                name='Tinggi'
                                onChange={this.onChangeField}
                                value={Tinggi ? Tinggi : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                variant='outlined'
                                type='number'
                                step="0.01"
                                label='Berat'
                                name='Berat'
                                onChange={this.onChangeField}
                                value={Berat ? Berat : ''}
                            />
                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='number'
                                label='No KTP'
                                name='KTP'
                                onChange={this.onChangeField}
                                value={KTP ? KTP : ''
                                }
                            />
                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='number'
                                label='No KartuKeluarga'
                                name='KartuKeluarga'
                                onChange={this.onChangeField}
                                value={KartuKeluarga ? KartuKeluarga : ''
                                }
                            />
                            <FormControl
                                style={st_textfield}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Status Perkawinan
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Status Perkawinan"
                                    name='StatusKawin'
                                    value={StatusKawin ? StatusKawin : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpKawin.map((option, index) =>
                                        <option key={`OpKawin_${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            <TextField
                                style={st_textfield}
                                variant='outlined'
                                type='text'
                                label='Hobi'
                                name='Hobi'
                                onChange={this.onChangeField}
                                value={Hobi ? Hobi : ''
                                }
                            />
                            <FormControl
                                style={{ ...st_textfield, ...st_Half }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Memiliki SIM A?
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Memiliki SIM A"
                                    name='SimA'
                                    value={SimA ? SimA : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpSIM.map((option, index) =>
                                        <option key={`OpSIMA_${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            {SimA === 'Ya' ?
                                <TextField
                                    style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                    variant='outlined'
                                    type='date'
                                    label='Sim A Exp'
                                    name='ExpSimA'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={this.onChangeField}
                                    required={SimA === 'Ya' ? true : false}
                                    value={ExpSimA ? ExpSimA : ''}
                                />
                                : <Fragment></Fragment>}
                            <br />
                            <FormControl
                                style={{ ...st_textfield, ...st_Half }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Memiliki SIM B?
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Memiliki SIM B?"
                                    name='SimB'
                                    value={SimB ? SimB : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpSIM.map((option, index) =>
                                        <option key={`OpSIMB_${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            {SimB === 'Ya' ?
                                <TextField
                                    style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                    variant='outlined'
                                    type='date'
                                    label='Sim B Exp'
                                    name='ExpSimB'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={this.onChangeField}
                                    required={SimB === 'Ya' ? true : false}
                                    value={ExpSimB ? ExpSimB : ''}
                                />
                                : <Fragment></Fragment>}
                            <br />
                            <FormControl
                                style={{ ...st_textfield, ...st_Half }}
                                variant="filled"
                            >
                                <InputLabel
                                    shrink
                                >
                                    Memiliki SIM C?
                                </InputLabel>
                                <Select
                                    native
                                    style={{ backgroundColor: 'white' }}
                                    onChange={this.onChangeField}
                                    label="Memiliki SIM C?"
                                    name='SimC'
                                    value={SimC ? SimC : ''}
                                >
                                    <option value="" disabled> -- select an option -- </option>
                                    {OpSIM.map((option, index) =>
                                        <option key={`OpSIMC_${index}`} value={option}>{option}</option>
                                    )}
                                </Select>
                            </FormControl>
                            {SimC === 'Ya' ?
                                <TextField
                                    style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                    variant='outlined'
                                    type='date'
                                    label='Sim C Exp'
                                    name='ExpSimC'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={this.onChangeField}
                                    value={ExpSimC ? ExpSimC : ''}
                                    required={SimC === 'Ya' ? true : false}
                                />
                                : <Fragment></Fragment>}
                            <br />
                            <TextField
                                style={{ ...st_textfield, ...st_Half }}
                                variant='outlined'
                                type='text'
                                label='Kendaraan'
                                name='Kendaraan'
                                onChange={this.onChangeField}
                                value={Kendaraan ? Kendaraan : ''}
                            />
                            <TextField
                                style={{ ...st_textfield, ...st_Half, marginLeft: '5%' }}
                                variant='outlined'
                                type='text'
                                label='Milik'
                                name='KendaraanMilik'
                                onChange={this.onChangeField}
                                value={KendaraanMilik ? KendaraanMilik : ''}
                            /><br />
                            <label>Foto:</label><br />
                            <input type='file' accept='image/*' onChange={this.File_OnChange} name='Foto' /><br />
                            <center>
                                <Button
                                    variant='contained'
                                    style={{ width: '60%', margin: '2% 0 5% 0' }}
                                    type='submit'
                                >
                                    Save
                                </Button>
                            </center>
                        </form>
                    </Fragment>}
            </Fragment >
        )
    }
}

const mapStateToProps = state => ({
    AccountActionId: state.Account.AccountActionId,
    isBiodataLoading: state.Account.isBiodataLoading,
    Biodata: state.Account.Biodata,
})

export default connect(mapStateToProps, { Update_Biodata })(Biodata)